export default () => {
  const DESKTOP_BREAKPOINT = 1024

  return {
    init() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
      if (window.innerWidth < DESKTOP_BREAKPOINT) return

      const video = this.$refs.video as HTMLVideoElement | undefined
      if (!video) return

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return
          observer.disconnect()

          const webm = document.createElement('source')
          webm.type = 'video/webm'
          webm.src = video.dataset.srcWebm!

          const mp4 = document.createElement('source')
          mp4.type = 'video/mp4'
          mp4.src = video.dataset.srcMp4!

          video.append(webm, mp4)
          video.load()
          video.play().catch(() => {})
        },
        { rootMargin: '200px' },
      )

      observer.observe(this.$el)
    },
  }
}
